import { useEffect, useState } from "react";
import { IMenuItem } from "../types";
import { BottomBarProps } from "./types";

export const useBottomBarController = ({
  onItemPress,
  items
}: Pick<BottomBarProps, "onItemPress" | "items">) => {
  const [selected, setSelected] = useState<IMenuItem | null>(null);

  useEffect(() => {
    if (typeof window !== "undefined" && window.location.pathname) {
      const path = window.location.pathname.replace("/", "");
      const item = items.find((item) => item.key === path);
      setSelected(item || items[0]);
    }
  }, [items]);

  const handlerItemPress = (item: IMenuItem) => {
    if (item.isSelectable) {
      setSelected(item);
    }

    onItemPress?.(item);
  };

  return { selected, handlerItemPress };
};
